<template>
  <va-card>
    <va-card>
      <div class="row align--center">
        <div class="flex xs12 md4">
          <va-select
            :label="'Select source product'"
            v-model="addProduct.product"
            searchable
            textBy="display_name"
            keyBy="value"
            :options="sorceProduts"
          />
        </div>
        <div class="flex xs12 md4">
          <va-select
            :label="'Select Supllier'"
            v-model="addProduct.supplier"
            searchable
            textBy="display_name"
            keyBy="value"
            :options="suppliers"
          />
        </div>
        <div class="flex md4 sm6 xs12">
          <va-input
            v-model="addProduct.supplier_product_id"
            placeholder="ID supplier product"
            type="number"
          >
            <va-button
              slot="append"
              style="margin-right: 0; white-space: nowrap;"
              small
              :disabled="
                addProduct.supplier_product_id &&
                  addProduct.supplier &&
                  addProduct.product
                  ? false
                  : true
              "
              @click="addSupplierProduct"
            >
              Add product
            </va-button>
          </va-input>
        </div>
      </div>
    </va-card>
    <div class="row align--center">
      <div class="flex xs12 md3">
        <va-input
          v-model="filter.search"
          :placeholder="'Search by customer name or email or Woo id'"
          removable
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div class="flex xs12 md3">
        <va-select
          :label="'Select Source site'"
          v-model="filter.product__source_site__domain_name"
          searchable
          removable
          textBy="description"
          class="multiSelect"
          :options="allowedSourceSites"
        />
      </div>
      <div class="flex xs12 md3">
        <va-select
          :label="'Select SUPPLIER'"
          v-model="filter.supplier__name"
          searchable
          removable
          textBy="description"
          class="multiSelect"
          :options="dataSuppliers.map(item => item.name)"
        />
      </div>
      <div class="flex xs12 md3">
        <va-select
          v-model="filter.limit"
          :label="$t('tables.perPage')"
          :options="perPageOptions"
          noClear
        />
      </div>
    </div>
    <va-data-table
      :fields="fields"
      :data="supplierProducts"
      api-mode
      :totalPages="totalPages"
      :per-page="parseInt(filter.limit)"
      :loading="loading"
      :rowClass="() => 'supplierProductsTable'"
      @page-selected="readPage"
      @row-clicked="viewProduct"
    >
      <template slot="source_site" slot-scope="props">
        {{ props.rowData.product.service + ' ' + props.rowData.product.name }}
      </template>
    </va-data-table>

    <va-modal
      v-model="showOrderModal"
      size="large"
      :title="$t('modal.smallTitle')"
      okText="Edit"
      noOutsideDismiss
      @ok="editProduct"
    >
      <div class="row align--center">
        <div class="flex xs12">
          <va-select
            :label="'Select Supllier'"
            v-model="selectedProduct.supplier"
            searchable
            textBy="display_name"
            keyBy="value"
            :options="suppliers"
          />
          <va-input
            v-model="selectedProduct.supplier_product_id"
            placeholder="ID supplier product"
            type="number"
          >
          </va-input>
        </div>
        <div class="flex m-auto">
          <va-button @click="deleteProduct" class="align--center" color="danger"
          >Delete</va-button
          >
        </div>
      </div>
    </va-modal>
  </va-card>
</template>
<script>
import { debounce } from 'lodash'
export default {
  data () {
    return {
      showOrderModal: false,
      addProduct: {
        product: '',
        supplier: '',
        supplier_product_id: '',
      },
      filter: {
        supplier__name: '',
        product__source_site__domain_name: '',
        search: this.$route.params.search,
        limit: '10',
        offset: '',
      },
      supplierProducts: [],
      perPageOptions: ['10', '20', '50', '100', '200'],
      selectedProduct: {},
      sorceProduts: [],
      suppliers: [],
    }
  },
  computed: {
    count () {
      return this.$store.getters.supplierProducts.count
    },
    totalPages () {
      return Math.ceil(this.count / this.filter.limit)
    },
    queryStringGet () {
      let Query = '?'
      for (const getKey in this.filter) {
        if (Object.hasOwnProperty.call(this.filter, getKey)) {
          const getValue = this.filter[getKey]

          Query += getValue ? `${getKey}=${getValue}&` : ''
        }
      }
      return Query.slice(0, -1)
    },
    dataSuppliers () {
      return this.$store.getters.dataSuppliers
    },
    allowedSourceSites () {
      return this.$store.getters.allowedSourceSitesList
    },
    loading () {
      return this.supplierProducts.length < 1
    },
    fields () {
      return [
        {
          name: 'id',
          title: this.$t('supplierProducts.id'),
        },
        {
          name: '__slot:source_site',
          title: this.$t('supplierProducts.source_site_product'),
        },
        {
          name: 'product.source_site',
          title: this.$t('supplierProducts.source_site'),
        },
        {
          name: 'product.price',
          title: this.$t('supplierProducts.price'),
        },
        {
          name: 'supplier',
          title: this.$t('supplierProducts.supplier'),
        },
        {
          name: 'supplier_product_id',
          title: this.$t('supplierProducts.supplier_product_id'),
        },
      ]
    },
  },
  methods: {
    async deleteProduct () {
      this.showOrderModal = false
      await this.$store.dispatch(
        'deleteSupplierProduct',
        this.selectedProduct.id,
      )
      this.selectedProduct = {}
      this.updateTable(this.queryStringGet)
    },
    async editProduct () {
      await this.$store.dispatch('updateSupplierProduct', this.selectedProduct)

      this.selectedProduct = {}
      this.updateTable(this.queryStringGet)
    },
    async addSupplierProduct () {
      const addProduct = {}
      for (const key in this.addProduct) {
        if (typeof this.addProduct[key] === 'object') {
          addProduct[key] = this.addProduct[key].value
        } else {
          addProduct[key] = this.addProduct[key]
        }
        this.addProduct[key] = ''
      }
      await this.$store.dispatch('addSupplierProduct', addProduct)
      this.updateTable(this.queryStringGet)
    },
    readPage (page = 1) {
      this.filter.offset = (page - 1) * this.filter.limit

      this.updateTable(this.queryStringGet)
    },
    updateTable (query) {
      this.$store.dispatch('searchSupplierProducts', query).then(() => {
        this.supplierProducts = this.$store.getters.supplierProducts.results
        if (this.$store.getters.supplierProducts.count === 0) {
          alert('Have not supplierProducts!')
        }
      })
    },
    viewProduct (selectedProduct) {
      for (const key in selectedProduct) {
        if (Object.hasOwnProperty.call(selectedProduct, key)) {
          this.selectedProduct[key] = selectedProduct[key]
        }
      }

      this.selectedProduct.product = this.selectedProduct.product.id
      this.showOrderModal = true
    },
  },
  watch: {
    filter: {
      handler: debounce(function () {
        localStorage.setItem('filterPerPage', this.filter.limit)
        this.updateTable(this.queryStringGet)
      }, 500),
      deep: true,
    },
  },
  created () {
    this.filter.limit = localStorage.getItem('filterPerPage') || '10'

    this.$store
      .dispatch('searchSupplierProducts', this.queryStringGet)
      .then(() => {
        this.supplierProducts = this.$store.getters.supplierProducts.results
        this.sorceProduts = this.$store.getters.supplierProducts.options.product.choices
        this.suppliers = this.$store.getters.supplierProducts.options.supplier.choices
        console.log(this.supplierProducts)
      })
    this.$store.dispatch('getSourcesSites')
    this.$store.dispatch('getAllSuppliers')
  },
}
</script>
<style lang="scss">
.source-site,
.middleware {
  padding: 0.375rem 1.25rem;
  width: 100%;
  display: block;
  text-align: center;
}

.supplierProductsTable {
  cursor: pointer;
}

.status {
  margin: 0;
  width: 100%;
  max-width: 100px;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}
</style>
